import { FC, ReactNode } from 'react';

import { BannerModerationStatus } from 'utils/constants/banner';
import { CampaignPauseReason, CampaignStatus } from 'utils/constants/dashboard';

import Icon, { IconAppearance, IconColor, IconKind, IconScale, IconShape, IconView } from 'bloko/blocks/icon';

import { FrontendStatusType } from 'store/models/dashboard';

import styles from 'components/Banner/Actions/IconStatus/IconStatus.module.less';

type BannerStatuses = {
    [key in BannerModerationStatus]: ReactNode;
};

type CampaignStatuses = {
    [key in Exclude<
        FrontendStatusType,
        CampaignStatus.Active | CampaignStatus.ActiveWithDelayedStart | CampaignStatus.InactiveDueToEndDate
    >]: ReactNode;
};

const bannerStatuses: BannerStatuses = {
    [BannerModerationStatus.New]: (
        <Icon view={IconView.Clock} initial={IconColor.Gray50} kind={IconKind.Default} scale={IconScale.Small} />
    ),
    [BannerModerationStatus.Banned]: (
        <Icon view={IconView.Ban} initial={IconColor.SpecialRedBranded} scale={IconScale.Small} />
    ),
    [BannerModerationStatus.Moderated]: (
        <Icon
            view={IconView.Checkmark}
            initial={IconColor.Green60}
            kind={IconKind.Single}
            appearance={IconAppearance.Outlined}
            scale={IconScale.Small}
        />
    ),
};

const campaignStatuses: CampaignStatuses = {
    [CampaignStatus.Archived]: (
        <Icon view={IconView.Trash} initial={IconColor.SpecialRedBranded} scale={IconScale.Small} />
    ),
    [CampaignStatus.Blocked]: (
        <Icon view={IconView.Ban} initial={IconColor.SpecialRedBranded} scale={IconScale.Small} />
    ),
    [CampaignPauseReason.BudgetExceeded]: (
        <Icon
            view={IconView.Exclamation}
            initial={IconColor.SpecialRedBranded}
            shape={IconShape.Triangle}
            scale={IconScale.Small}
        />
    ),
    [CampaignPauseReason.DailyBudgetExceedStatus]: (
        <Icon
            view={IconView.Exclamation}
            initial={IconColor.SpecialRedBranded}
            shape={IconShape.Triangle}
            scale={IconScale.Small}
        />
    ),
};

interface IconStatusProps {
    campaignStatus: FrontendStatusType;
    moderationStatus: BannerModerationStatus;
}

const IconStatus: FC<IconStatusProps> = ({ campaignStatus, moderationStatus }) => {
    if (
        campaignStatuses.hasOwnProperty(campaignStatus) &&
        campaignStatus !== CampaignStatus.Active &&
        campaignStatus !== CampaignStatus.ActiveWithDelayedStart &&
        campaignStatus !== CampaignStatus.InactiveDueToEndDate
    ) {
        return <div className={styles.bannerStatusIcon}>{campaignStatuses[campaignStatus]}</div>;
    }
    if (bannerStatuses.hasOwnProperty(moderationStatus)) {
        return <div className={styles.bannerStatusIcon}>{bannerStatuses[moderationStatus]}</div>;
    }
    return null;
};

export default IconStatus;
